import styled from "styled-components";
import { fluid } from "@/styles/utils/fluid";
import { Link } from "react-router-dom";
import { TypoTitle1 } from "@/styles/Styled.Typography";

export const OutlineWrapper = styled.div`
  width: 100%;
  border-top: 4px solid ${({ theme }) => theme.colors.onyx};
  border-bottom: 4px solid ${({ theme }) => theme.colors.onyx};
  article {
    border-bottom: 1px solid ${({ theme }) => theme.colors.onyx};
    &:last-child {
      border-bottom: none;
    }
    p {
      padding: 0;
    }
  }
`;

export const OutlineContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const OutlineLink = styled(Link)`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.onyx};
  h2 {
    transition: color 0.3s ease-in-out;
  }
  &:hover h2 {
    color: ${({ theme }) => theme.colors.imperialRed};
  }
  padding: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;

export const OutlineTitle = styled(TypoTitle1)`
  margin-bottom: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
`;
